export default __webpack_public_path__ + "static/StyreneA-Regular-Web-0c04c8e0e1bf371a435ccb28fdb93fa2.woff";